/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
/*:: export type SocialNetwork = {
  name: string,
  url: (text: string, url: string) => string,
  window?: {
    name: string,
    features: string,
    width: number,
    height: number,
  },
}; */

// https://jonsuh.com/blog/social-share-links/
// http://sharingbuttons.io/
export const facebook /*: SocialNetwork */ = {
  name: 'Facebook',
  url(text /*: string */, url /*: string */) {
    return `https://facebook.com/sharer/sharer.php?u=${url}`;
  },
  window: {
    name: 'facebook_share',
    features:
      'resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0',
    width: 660,
    height: 380,
  },
};
export const twitter /*: SocialNetwork */ = {
  // https://dev.twitter.com/web/tweet-button/web-intent
  name: 'Twitter',
  url(text /*: string */, url /*: string */) {
    return `https://twitter.com/intent/tweet/?text=${text}&url=${url}`;
  },
  window: {
    name: 'twitter_share',
    features: 'resizable=1,toolbar=0,menubar=0,status=0,location=0',
    width: 550,
    height: 400,
  },
};
export const email /*: SocialNetwork */ = {
  name: 'E-Mail',
  url(text /*: string */, body /*: string */) {
    return `mailto:?subject=${text}&body=${body}`;
  },
};
export const qrcode /*: SocialNetwork */ = {
  name: 'QR Code',
  url(text /*: string */, url /*: string */) {
    return '';
  },
};
